import React from 'react'

const Ovarlay = (props) => {
    return (
        <div onClick={() => props.close ? props.close(false) : null} className={`overlay-z fixed h-screen w-screen bg-black bg-opacity-25 top-0 left-0 ${props.class}`} />
    )
}

export default Ovarlay